import { render, staticRenderFns } from "./HiwTopSection.vue?vue&type=template&id=2b6f063c&scoped=true&"
var script = {}
import style0 from "./HiwTopSection.vue?vue&type=style&index=0&id=2b6f063c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6f063c",
  null
  
)

export default component.exports